import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';

export default class MSM_Settings_Sites extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();

		this.state = {

		}

		this.stored_param = {}; // to prepare to send to next screen
	}

	handlePrevious = () => {
		this.props.content_handler('MSM_Settings', this.props.param);
	}

	handleAddSite = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Add_Edit_Site', {
			site_id: null,
			site_info: null,
			temp_targ_list: {},
			val_targ_list: {}
		});
	}

	handleEditSite = (site_id) => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.stored_param.site_id = site_id;
		this.props.receiver.getMSMTempTargList(site_id);
	}

	rcvMSMTempTargList = (response) => {
		this.stored_param.temp_targ_list = response;
		this.props.receiver.getMSMValTargList(this.stored_param.site_id);
	}

	rcvMSMValTargList = (response) => {
		this.stored_param.val_targ_list = response;
		this.props.receiver.getMSMSiteInfo(this.stored_param.site_id);
	}

	rcvMSMSiteInfo = (response) => {
		this.props.content_handler('Add_Edit_Site', {
			site_id: this.stored_param.site_id,
			site_info: response[this.stored_param.site_id],
			temp_targ_list: this.stored_param.temp_targ_list,
			val_targ_list: this.stored_param.val_targ_list
		});
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			width: this.props.width - 40,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('sites')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={this.props.receiver.is_mobile ? 'add' : null}
						handleRightButton={this.handleAddSite}
					/>
					<div>
						{Object.keys(window.app.state.site_list).map((site_id) => {
							let site_info = window.app.state.site_list[site_id];
							return (
								<div style={button_style}>
									<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 60, textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }} onClick={() => this.handleEditSite(site_id)}>
										<span>{site_info.attr.name}</span>
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}